import * as React from 'react';

import { Card } from '../Card';
import { ICardsQuestionProps } from '../../types';

import * as styles from './styles.css';

export const CardsQuestion: React.FC<React.PropsWithChildren<ICardsQuestionProps>> = props => {
  return (
    <div className={styles['cards']}>
      {props.cards.map(card => (
        <Card key={card.value} {...card} onClick={props.handleSelect} iconType={props.iconType} />
      ))}
    </div>
  );
};

CardsQuestion.displayName = 'CardsQuestion';
